import { Bell, BellOff } from "lucide-react";
import { useEffect, useState } from "react";

import { useSession } from "../context/SessionContext";
import { useToast } from "../context/ToastContext";
import { canUsePush, hasActivePushSubscription, subscribeToPush, unsubscribeFromPush } from "../lib/push";

export function PushControl() {
  const { config } = useSession();
  const { showToast } = useToast();
  const [subscribed, setSubscribed] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let active = true;
    void hasActivePushSubscription().then((value) => { if (active) setSubscribed(value); }).catch(() => { if (active) setSubscribed(false); });
    return () => { active = false; };
  }, []);

  if (!canUsePush()) {
    return <p className="muted-copy">On iPhone or iPad (iOS 16.4+), add this workspace to your Home Screen, open that app, then enable push here. Otherwise, use a browser that supports Web Push.</p>;
  }

  async function toggle() {
    setBusy(true);
    try {
      if (subscribed) {
        await unsubscribeFromPush();
        setSubscribed(false);
        showToast("Push notifications turned off.", "success");
      } else {
        const key = config.push?.vapidPublicKey;
        if (!key) throw new Error("Push notifications are not configured on this server yet.");
        await subscribeToPush(key);
        setSubscribed(true);
        showToast("Push notifications are on.", "success");
      }
    } catch (requestError) {
      showToast(requestError instanceof Error ? requestError.message : "Push setup failed.", "error");
    } finally {
      setBusy(false);
    }
  }

  return (
    <button className={`button ${subscribed ? "button--secondary" : "button--primary"}`} type="button" onClick={toggle} disabled={busy}>
      {subscribed ? <BellOff aria-hidden="true" size={17} /> : <Bell aria-hidden="true" size={17} />}
      {busy ? "Updating…" : subscribed ? "Turn off push" : "Enable push"}
    </button>
  );
}
